import { Theme } from '@mui/material';

export default function Chip(theme: Theme) {
    return {
        MuiChip: {
            styleOverrides: {
                root: {
                    padding: theme.spacing(0.5),
                    height: '28px'
                },
                colorWarning: {
                    backgroundColor: theme.palette.warning[300]
                },
                colorSuccess: {
                    backgroundColor: theme.palette.success[300]
                },
                colorError: {
                    backgroundColor: theme.palette.error[400]
                }
            }
        }
    };
}
